import {paData} from "./framework/paData";

export const Data = {
    tree: {},
    categoryMap: {},
    init() {
        window.Data = this;
        for (let id in paData.data.decades) {
            Data.tree[id] = {
                id: id,
                name: paData.data.decades[id].name,
                data: {}
            };
        }
        for (let id in paData.data.names) {
            Data.tree[paData.data.names[id].decade].data[paData.data.names[id].id] = paData.data.names[id];
            let categoryData = {
                name: paData.data.names[id].name,
                decade: paData.data.names[id].decade,
                gender: paData.data.names[id].gender,
            };
            Data.categoryMap[paData.data.names[id].id] = categoryData;
        }
    },
};


// WEBPACK FOOTER //
// ./src/js/Data.js